module.exports = __webpack_public_path__ + "static/media/arrow-left-select.0a18059a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ventajas/arrow-left-select.svg
// module id = 173
// module chunks = 0